import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Payment } from '../../models/payment.model';

export interface CreatePaymentPayload {
  originId?: string;
  serviceCenterId?: string | null;
  typeOfOriginPayment: number; // 1 credit card, etc.
  value: number;
  transactionCurrencyCode?: string;
  ivaAmount?: number;
  islrAmount?: number;
  handlesTaxWithholdings?: boolean;
  cardToken?: string; // optional when attaching directly
  paymentExchangeRate?: number; // exchange rate applied to the charged amount
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private api = environment.api;
  constructor(private http: HttpClient) {}

  /**
   * Creates a payment (adjust endpoint if backend differs)
   */
  createPayment(payload: CreatePaymentPayload): Observable<Payment> {
    const endpoint = `${this.api}/api/v1/payment/insert-payment`;
    console.log('[PaymentService] createPayment POST', { endpoint, payload });
    return this.http.post<Payment>(endpoint, payload);
  }

  public PayOrdersById(paymentOrdersId: string, data: any): Observable<any> {
    let urlbase = `${environment.api}/api/v1/mobile-payment/pay-orders-by-mobile-payment/${paymentOrdersId}`;
    return this.http.post<any>(urlbase, data);
  }

  /**
   * Attaches a stripe token to existing payment (placeholder endpoint)
   */
  attachCardToken(paymentId: string, token: string): Observable<Payment> {
    const endpoint = `${this.api}/api/v1/payment/${paymentId}/attach-card`;
    const body = { cardToken: token };
    console.log('[PaymentService] attachCardToken POST', { endpoint, body });
    return this.http.post<Payment>(endpoint, body);
  }

  public EvenLog(data: any): Observable<any> {
    let urlbase = `${this.api}/api/EventLog`;
    return this.http.post<any>(urlbase, data);
  }

  public GetBanks(bankId: string, scid: string): Observable<any> {
    let urlbase = `${environment.api}/api/v1/mobile-payment/list-bank/${bankId}/${scid}`;
    return this.http.get<any>(urlbase);
  }
}
